var map = {
	"./i/a.jpg": "2e2c",
	"./ii/a.jpg": "4073",
	"./iii/a.jpg": "e034",
	"./iv/a.jpg": "c2d3",
	"./ix/a.jpg": "0bc6",
	"./v/a.jpg": "7a0f",
	"./vi/a.jpg": "83e7",
	"./vii/a.jpg": "e488",
	"./viii/a.jpg": "eeb0",
	"./writing/a.jpg": "6003",
	"./x/a.jpg": "a549",
	"./xi/a.jpg": "6037",
	"./xii/a.jpg": "6694"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f830";